import { render, staticRenderFns } from "./WalletTable.vue?vue&type=template&id=0ad66031"
import script from "./WalletTable.vue?vue&type=script&lang=js"
export * from "./WalletTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports